
export const SELLTOANYONE = 'sell_on_market';
export const SELLTOFRIEND = 'sell_to_friend';
